import { PROCESS } from "../../data/content";
import { Reveal } from "./Reveal";

const Overline = ({ children, num }) => (
  <div className="flex items-center gap-4 mb-5">
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-500">{num}</span>
    <span className="h-px w-10 bg-white/20" />
    <span className="font-mono text-xs uppercase tracking-[0.25em] text-neutral-400">{children}</span>
  </div>
);

export const Process = () => {
  return (
    <section id="process" data-testid="process-section" className="relative border-t border-white/10 bg-[#0C0C0C]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <Overline num="02">How Atlas Supports Agencies</Overline>
        <h2 className="font-sans font-black uppercase tracking-tight text-4xl md:text-5xl lg:text-6xl text-white max-w-3xl leading-[0.95]">
          One Accountable Channel, <span className="metal-text">Four Disciplined Steps</span>
        </h2>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {PROCESS.map((p, i) => {
            const Pi = p.icon;
            return (
              <Reveal key={p.num} delay={i * 0.1} className="flex">
              <div data-testid={`process-step-${p.num}`} className="w-full group bg-[#0A0A0A] p-8 hover:bg-[#121212] transition-colors">
                <div className="flex items-center justify-between">
                  <Pi size={30} strokeWidth={1.5} className="text-white" />
                  <span className="font-mono text-4xl font-bold text-neutral-800 group-hover:text-neutral-600 transition-colors">{p.num}</span>
                </div>
                <h3 className="mt-6 font-sans font-bold uppercase tracking-tight text-2xl text-white">{p.title}</h3>
                <p className="mt-3 font-body text-neutral-400 text-sm leading-relaxed">{p.desc}</p>
              </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
